import { render, staticRenderFns, recyclableRender, components } from "./u-parse.vue?vue&type=template&id=64ac03df&"
var renderjs
import script from "./u-parse.vue?vue&type=script&lang=js&"
export * from "./u-parse.vue?vue&type=script&lang=js&"
import style0 from "./u-parse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-parse/u-parse.vue"
export default component.exports